import React, { useState } from "react";
import { Box, TextField, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const PersonalInformationForm = ({ onChildData }) => {
  const [personalInfo, setPersonalInfo] = useState({
    name: "",
    surname: "",
    date_of_birth: "",
    country: "",
    city: "",
    address: "",
    phone_prefix: "",
    phone: "",
    email: "",
    github: "",
    linkedin: "",
    portal: "",
  });
  //const [parsedYaml, setParsedYaml] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPersonalInfo({
      ...personalInfo,
      [name]: value,
    });
    //setParsedYaml({"personal_information":personalInfo})
    onChildData({ personal_information: {
      ...personalInfo,
      [name]: value,
    } });
  };

  const formatPersonalInfo = () => {
    let output = "personal_information:\n";
    Object.entries(personalInfo).forEach(([key, value]) => {
      output += `  ${key}: "${value}"\n`;
    });
    return output;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedData = formatPersonalInfo();
    console.log(formattedData);
    // You can also send this data to an API or perform any other action here
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3, pt: 2, pb: 2 }}>
      <Typography variant="h6" sx={{ display: "none" }} gutterBottom>
        Personal Information
      </Typography>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Personal Information</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            {Object.keys(personalInfo).map((key) => (
              <Grid size={6} key={key}>
                <Item>
                  {key === "date_of_birth" ? (
                    <TextField
                      fullWidth
                      label={key.replace(/_/g, " ").toUpperCase()}
                      name={key}
                      type="date"
                      size="small"
                      value={personalInfo[key]}
                      onChange={handleChange}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  ) : (
                    <TextField
                      fullWidth
                      label={key.replace(/_/g, " ").toUpperCase()}
                      name={key}
                      value={personalInfo[key]}
                      onChange={handleChange}
                      required
                      size="small"
                    />
                  )}
                </Item>
              </Grid>
            ))}
          </Grid>
          <Button type="submit" className="btn-submit" variant="contained" sx={{ mt: 2,display:'none' }}>
            Submit
          </Button>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default PersonalInformationForm;
